// Arachne footer (sections/footer.liquid): country/language search filter and the
// newsletter form. Loaded with defer; reads the section id and its translated strings
// from data attributes on .arachne-footer.
(function() {
  // Run once even if the theme editor re-inserts the tag; re-renders are handled by the
  // shopify:section:load listeners below.
  if (window.__arachneFooterJs) return;
  window.__arachneFooterJs = true;

  // ========================================
  // Localization Search Filter - COMPLETE REWRITE
  // This overrides/supplements Shopify's localization-form.js
  // ========================================
  (function() {
    const DEBUG = false; // Set to true to enable console logging

    function log(...args) {
      if (DEBUG) console.log('[Arachne Footer]', ...args);
    }

    // Normalize string for search (remove diacritics, lowercase)
    function normalizeString(str) {
      return str
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
    }

    function initLocalizationSearch() {
      log('Initializing localization search...');

      // Find the footer localization area
      const localizationArea = document.querySelector('.arachne-footer__localization');
      if (!localizationArea) {
        log('No .arachne-footer__localization found');
        return;
      }

      // Find ALL inputs in the localization area that could be search inputs
      // Shopify uses name="country_filter" for the search input
      const allInputs = localizationArea.querySelectorAll('input');
      log('Found inputs:', allInputs.length, allInputs);

      allInputs.forEach((input, index) => {
        // Skip hidden inputs (like country_code)
        if (input.type === 'hidden' || input.name === 'country_code' || input.name === 'locale_code') {
          log(`Skipping hidden/system input ${index}:`, input.name);
          return;
        }

        // Skip if already initialized
        if (input.dataset.arachneSearchInit === 'true') {
          log(`Input ${index} already initialized`);
          return;
        }

        log(`Setting up search on input ${index}:`, input.name, input.type, input);
        input.dataset.arachneSearchInit = 'true';

        // Find the container - the localization-form custom element
        const localizationForm = input.closest('localization-form');
        const listWrapper = input.closest('.disclosure__list-wrapper') || 
                            input.closest('.localization-selector') ||
                            input.closest('.country-selector');

        const container = localizationForm || listWrapper;

        if (!container) {
          log(`No container found for input ${index}`);
          return;
        }

        log(`Container for input ${index}:`, container);

        // Find all country/language links
        const getLinks = () => {
          const links = container.querySelectorAll('.disclosure__list a, .country-selector__list a, .localization-selector__list a, a[data-value]');
          log(`Found ${links.length} links to filter`);
          return links;
        };

        // Get popular countries section
        const getPopularSection = () => container.querySelector('.popular-countries');

        // The filter function
        function filterCountries() {
          const searchValue = normalizeString(input.value);
          log(`Filtering with search value: "${searchValue}"`);

          const links = getLinks();
          const popularSection = getPopularSection();
          let visibleCount = 0;

          // Hide popular countries when searching
          if (popularSection) {
            if (searchValue) {
              popularSection.classList.add('hidden');
              popularSection.style.display = 'none';
            } else {
              popularSection.classList.remove('hidden');
              popularSection.style.display = '';
            }
          }

          // Filter each link
          links.forEach((link, i) => {
            const text = link.textContent || '';
            const normalizedText = normalizeString(text);
            const matches = !searchValue || normalizedText.includes(searchValue);
            const listItem = link.closest('li');

            if (matches) {
              link.classList.remove('hidden');
              link.style.display = '';
              if (listItem) {
                listItem.classList.remove('hidden');
                listItem.style.display = '';
              }
              visibleCount++;
            } else {
              link.classList.add('hidden');
              link.style.display = 'none';
              if (listItem) {
                listItem.classList.add('hidden');
                listItem.style.display = 'none';
              }
            }
          });

          log(`Filtering complete: ${visibleCount} items visible`);

          // Handle no results message
          let noResults = container.querySelector('.arachne-no-results');
          if (visibleCount === 0 && searchValue) {
            if (!noResults) {
              noResults = document.createElement('div');
              noResults.className = 'arachne-no-results';
              noResults.style.cssText = 'color: #CCCCCC; font-size: 14px; padding: 1rem; text-align: center;';
              noResults.textContent = (container.closest('.arachne-footer') || { dataset: {} }).dataset.noCountries || '';
              const list = container.querySelector('.disclosure__list, .country-selector__list, ul');
              if (list && list.parentNode) {
                list.parentNode.insertBefore(noResults, list.nextSibling);
              }
            }
            noResults.style.display = 'block';
          } else if (noResults) {
            noResults.style.display = 'none';
          }
        }

        // CRITICAL: Attach event listeners
        input.addEventListener('input', function(e) {
          log('Input event fired:', e.target.value);
          filterCountries();
        });

        input.addEventListener('keyup', function(e) {
          log('Keyup event fired:', e.target.value);
          filterCountries();
        });

        // Prevent form submission on Enter
        input.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            log('Enter key prevented');
          }
        });

        // Reset function
        function resetFilter() {
          log('Resetting filter');
          input.value = '';
          const links = getLinks();
          links.forEach(link => {
            link.classList.remove('hidden');
            link.style.display = '';
            const listItem = link.closest('li');
            if (listItem) {
              listItem.classList.remove('hidden');
              listItem.style.display = '';
            }
          });
          const popularSection = getPopularSection();
          if (popularSection) {
            popularSection.classList.remove('hidden');
            popularSection.style.display = '';
          }
          const noResults = container.querySelector('.arachne-no-results');
          if (noResults) noResults.style.display = 'none';
        }

        // Watch for panel close via hidden attribute
        const panel = container.querySelector('.disclosure__list-wrapper, [hidden]');
        if (panel) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === 'hidden' && panel.hasAttribute('hidden')) {
                resetFilter();
              }
            });
          });
          observer.observe(panel, { attributes: true });
        }

        // Watch for button aria-expanded changes
        const button = container.querySelector('.disclosure__button, [aria-expanded]');
        if (button) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === 'aria-expanded') {
                if (button.getAttribute('aria-expanded') === 'false') {
                  resetFilter();
                }
              }
            });
          });
          observer.observe(button, { attributes: true });
        }

        log(`Search fully initialized for input ${index}`);
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLocalizationSearch);
    } else {
      initLocalizationSearch();
    }

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', initLocalizationSearch);
    // No retry timers or click re-init: the selector markup is rendered by this
    // section above this script and never injected later, so one init is enough.
  })();

  // ========================================
  // Newsletter Form
  // ========================================
  (function() {
    function initNewsletter() {
      document.querySelectorAll('.arachne-footer[data-section-id]').forEach(function(root) {
        const sectionId = root.dataset.sectionId;
        const invalidEmail = root.dataset.invalidEmail || '';
        const form = document.getElementById(`footer-newsletter-ajax-${sectionId}`);
        const formWrapper = document.getElementById(`footer-form-wrapper-${sectionId}`);
        const successEl = document.getElementById(`footer-newsletter-success-${sectionId}`);
        const errorEl = document.getElementById(`footer-newsletter-error-${sectionId}`);
        const errorText = document.getElementById(`footer-newsletter-error-text-${sectionId}`);
        const button = document.getElementById(`footer-newsletter-button-${sectionId}`);
        const emailInput = document.getElementById(`footer-newsletter-email-${sectionId}`);

        if (!form || form.dataset.arachneNlInit === 'true') return;
        form.dataset.arachneNlInit = 'true';

        // Server-rendered success (no-JS / fallback submit): hide the form.
        if (successEl.classList.contains('is-visible')) {
          formWrapper.classList.add('is-hidden');
          formWrapper.inert = true;
        }

        // Shopify's spam protection (hCaptcha) binds to this form on first focus. It keeps a
        // submit function already set on the form and calls it once it has added its token,
        // so the background post below goes out once, with the token.
        const nativeSubmit = HTMLFormElement.prototype.submit;
        let submitNormally = false;
        let stuckTimer;
        // Already bound (focused before this deferred file ran): it holds the native submit,
        // so leave its token-then-submit in place rather than post without a token.
        if (!form.hasAttribute('data-hcaptcha-bound')) {
          try { form.submit = postInBackground; } catch (err) {}
        }

        // Capture phase, so this runs before the captcha's own listener even when it bound first.
        form.addEventListener('submit', function(e) {
          errorEl.classList.remove('is-visible');
          errorEl.setAttribute('aria-hidden', 'true');
          emailInput.removeAttribute('aria-invalid');
          emailInput.removeAttribute('aria-describedby');

          const email = emailInput.value.trim();
          if (!email || !isValidEmail(email)) {
            e.preventDefault();
            // The captcha's own submit listener ignores preventDefault: keep it from posting this address.
            e.stopImmediatePropagation();
            showError(invalidEmail);
            return;
          }

          button.classList.add('is-submitting');
          button.disabled = true;
          clearTimeout(stuckTimer);
          stuckTimer = setTimeout(resetButton, 20000); // captcha closed: let them try again
          // Captcha ready: it cancels this event, adds its token, then calls form.submit().
          if (form.hasAttribute('data-hcaptcha-bound')) return;
          e.preventDefault();
          // Captcha still loading (fast autofill on a slow connection): wait for it.
          if (form.dataset.cptcha === 'true') waitForCaptcha();
          else postInBackground();
        }, true);

        function waitForCaptcha() {
          let waitTimer;
          const observer = new MutationObserver(() => {
            if (!form.hasAttribute('data-hcaptcha-bound')) return;
            observer.disconnect();
            clearTimeout(waitTimer);
            form.submit(); // the captcha's submit: token, then postInBackground
          });
          observer.observe(form, { attributes: true, attributeFilter: ['data-hcaptcha-bound'] });
          waitTimer = setTimeout(() => { observer.disconnect(); postInBackground(); }, 8000);
        }

        // Post in the background and only show success once Shopify confirms it
        // (it redirects with customer_posted=true). Anything else (spam challenge,
        // validation error, network failure) submits the page normally so the
        // visitor sees Shopify's real response instead of a false "success".
        function postInBackground() {
          clearTimeout(stuckTimer);
          if (!isValidEmail(emailInput.value.trim())) { resetButton(); return; }
          if (submitNormally) { nativeSubmit.call(form); return; }
          fetch(form.action, { method: 'POST', body: new URLSearchParams(new FormData(form)) })
            .then((response) => {
              if (response.ok && response.url.indexOf('customer_posted=true') !== -1) showSuccess();
              else fallbackSubmit();
            })
            .catch(fallbackSubmit);
        }

        function fallbackSubmit() { submitNormally = true; form.submit(); } // fresh token when bound

        function resetButton() {
          button.classList.remove('is-submitting');
          button.disabled = false;
        }

        function showSuccess() {
          formWrapper.classList.add('is-hidden');
          setTimeout(() => {
            successEl.classList.add('is-visible');
            successEl.removeAttribute('aria-hidden');
            successEl.focus({ preventScroll: true });
            formWrapper.inert = true;
          }, 300);
        }

        function showError(message) {
          errorText.textContent = message;
          errorEl.classList.add('is-visible');
          errorEl.removeAttribute('aria-hidden');
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.setAttribute('aria-describedby', errorText.id);
          button.classList.remove('is-submitting');
          button.disabled = false;
          emailInput.focus();
        }

        function isValidEmail(email) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        }
      });
    }

    initNewsletter();
    // Theme editor: the section is re-rendered without re-running this file
    document.addEventListener('shopify:section:load', initNewsletter);
  })();
})();
